import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Box,
  Chip,
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material'
import { ExpandLess, ExpandMore, ReportProblemOutlined } from '@mui/icons-material'
import { statusColor } from './tileColors'

// Every KPI currently in error state across all sections, deep-linking to the
// section page it lives on.
const AttentionList = ({ items, search }) => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const colors = statusColor('error')

  if (!items?.length) return null

  return (
    <Paper sx={{ borderRadius: 3, overflow: 'hidden' }}>
      <ListItemButton onClick={() => setOpen((previous) => !previous)}>
        <Stack direction="row" alignItems="center" gap={1} flex={1}>
          <ReportProblemOutlined sx={{ color: colors.main }} />
          <Typography fontWeight={700}>Needs attention</Typography>
          <Chip
            size="small"
            label={items.length}
            sx={{ backgroundColor: `${colors.main}22`, color: colors.main, fontWeight: 700 }}
          />
        </Stack>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open}>
        <List dense disablePadding sx={{ pb: 1 }}>
          {items.map((item) => (
            <ListItemButton
              key={`${item.section}-${item.key}`}
              onClick={() => navigate(`/kpi/${item.section}${search}`)}
              sx={{ pl: 3 }}
            >
              <ListItemText
                primary={
                  <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
                    <Typography variant="body2">{item.label}</Typography>
                    <Chip size="small" variant="outlined" label={item.sectionName} />
                  </Stack>
                }
              />
              <Box textAlign="right" minWidth={110}>
                <Typography variant="body2" fontWeight={700} sx={{ color: colors.main }}>
                  {Math.round(item.percent)}%
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  target {item.reverse ? '≤' : '≥'} {item.target}%
                </Typography>
              </Box>
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </Paper>
  )
}

export default AttentionList
